import React, { useContext } from "react";
import { FullModal } from "../../../modals/fullModal";
import { useNavigate } from "react-router-dom";
import Button from "../../../../../../components/world/rmc/Button";
import { RmcContext } from "../../../../../../components/context/RmcContext";

const EarnMore = [
  {
    intro: "I’m Live (Daily Check-In)",
    description:
      "Start each day by tapping the “I’m Live” button — it's the easiest and most consistent way to earn points. Every time you check in, you're not just earning points; you're building momentum. The more consecutive days you check in, the more your bonus multiplies through check-in streaks, rewarding consistency. But it doesn’t stop there. Each check-in also grants you a ticket into the weekly lucky draw where you stand a chance to win airtime, cash prizes, or other surprise gifts. So with just one tap daily, you're stacking points and unlocking more chances to win — even before the major monthly prizes roll out. ",
  },
  {
    intro: "Kingdom Quest Trivia",
    description:
      "Test your knowledge and climb the ranks through our interactive Kingdom Quest Trivia. Every correct answer instantly boosts your points, and answering quickly earns you even more bonuses. It’s not just about getting it right — it’s about how fast you get it right. Be cautious, though — wrong answers come with a small point deduction, so think smart and stay sharp. To really dominate the leaderboard, make sure you play the trivia every single day, and even multiple times throughout the day. The more you play, the more points you rack up — making it one of the fastest and most rewarding ways to boost your chances of unlocking the biggest rewards.",
  },
  {
    intro: "Daily Logins (Streaks)",
    description:
      "Consistency is everything in the RMC World. Each day you log into the app adds to your streak — and that streak is your ticket to earning bonus points and unlocking exclusive badges. Hitting key streak milestones like 7, 14, or 30 consecutive days gives you special rewards that boost your leaderboard standing. To keep your streak alive and your points flowing, make it a habit to check in daily and dive into the available challenges. Missing a day resets your progress, so stay locked in and stay active — the more consistent you are, the more you gain.",
  },
  {
    intro: "Monthly Leaderboard & Big Rewards",
    description:
      "This is where your hustle pays off — big time. Every move you make in RMC World — from your check-ins to trivia wins to daily logins — earns you points and pushes you higher up the leaderboard. And at the end of each month, the top scorers don’t just get bragging rights… they get the ultimate rewards. We’re talking ₦250,000. ₦500,000. ₦1 Million. All-expense-paid trips. Cars. Gadgets.  Even a brand-new house! The more consistent and committed you are, the closer you get to unlocking life-changing prizes. So keep showing up. Keep playing. Keep checking in. Because the leaderboard isn’t just a chart — it’s your path to something massive. Let the countdown begin — this month could be yours to own.",
  },
];

export const HowToEarnMorePoints = () => {
  const navigate = useNavigate();
  const { slug } = useContext(RmcContext);
  return (
    <FullModal>
      <div className="px-4 pt-16 h-full overflow-y-scroll hidden-scrollbar">
        <div className="text-center mb-6">
          <p className="text-2xl text-white font-semibold">
            How to Earn More Points
          </p>
          <span className="text-xs text-[#FFFFFF80]">
            RMC World rewards your consistency, knowledge, and daily presence
            with points that push you up the leaderboard and unlock exciting
            prizes. Every tap and every correct answer brings you closer to
            life-changing rewards — from ₦1,000 airtime to a car or even a
            house.
          </span>
        </div>

        <div>
          <p className="text-xl text-white font-semibold ">
            How to Earn More Points
          </p>
          <div className="flex flex-col gap-8 mt-5 mb-12">
            {EarnMore.map((x, i) => {
              return (
                <div key={i} className="text-[#FFFFFFBF] flex ">
                  <span className="mr-1 text-xs">{i + 1}.</span>
                  <div className="text-xs">
                    <span>{x.intro}:</span>{" "}
                    <span className="text-[#FFFFFF80]">{x.description}</span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="w-full flex flex-col gap-5 pb-10">
            <Button
              onClick={() => navigate(`/worlds/${slug}/home`)}
              text="Earn Points with Trivia"
              className="text-lg py-[18px]"
            />
            <Button
              onClick={() => navigate(`/worlds/${slug}/live`)}
              text="Check in & Enter Draw"
              className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
            />
          </div>
        </div>
      </div>
    </FullModal>
  );
};
